import { Component, OnInit } from '@angular/core';
import { Pic } from 'src/app/open-age/core/models/pic.model';
import { RoleService } from 'src/app/open-age/core/services';
import { Organization, Role, Tenant } from 'src/app/open-age/directory/models';
import { Link, Nav } from '~/app/open-age/core/structures';
import { ReportAreaService } from '~/app/open-age/insight/services/report-area.service';
import { environment } from '../../../../environments/environment';
import { NavService } from '../../services/nav.service';
import { UxService } from '../../services/ux.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css'],
})
export class SideNavComponent implements OnInit {

  navs: Link[];
  active: Link[];
  currentTenant: Tenant;
  currentOrganization: Organization;
  currentRole: Role;

  logo: Pic;

  logoutUrl: string = 'https://openage.github.io/themes/oppos/v1/icons/nav/logout.svg';

  constructor(
    public auth: RoleService,
    public navService: NavService,
    public uxService: UxService,
    private reportAreaService: ReportAreaService
  ) {
    auth.tenantChanges.subscribe((t) => { this.currentTenant = t; });
    auth.organizationChanges.subscribe((t) => { this.currentOrganization = t; });
    auth.roleChanges.subscribe((r) => { this.currentRole = r; });

    navService.navsChanges.subscribe((n) => {
      this.navs = n;
      this.fetchReportAreas();
    });
    uxService.logoChanges.subscribe((n) => this.logo = n);
    navService.breadcrumbChanges.subscribe((links) => {
      this.active = links;
    });
  }

  ngOnInit() {
    this.currentRole = this.auth.currentRole();
    this.currentTenant = this.auth.currentTenant();
    this.currentOrganization = this.auth.currentOrganization();
    this.logo = this.uxService.getLogo();
    this.navs = this.navService.getNavs();
    this.fetchReportAreas();
  }

  isActive(nav: Link) {
    return this.active && this.active.find((i) => i.code === nav.code);
  }

  select(nav: Link) {
    this.navs.forEach((i) => i.current = null);
    nav.current = new Link();
    this.navService.goto(nav);
  }

  fetchReportAreas() {
    if (!this.navs) {
      return;
    }
    const report = this.navs.find((n) => n.title === 'Reports');

    if (!report) {
      return;
    }

    if (!this.currentRole) {
      report.items = [];
      return;
    }

    if (report.items && report.items.length) {
      return;
    }
    this.reportAreaService.search().subscribe((page) => {
      report.items = page.items.map((i) => {
        return new Link({
          title: i.name,
          routerLink: ['/reports', i.code],
          permissions: i.permissions
        });
      });
    });
  }

  logout(): void {
    this.auth.logout();
  }
}
